import { MouseEvent } from 'react';
import { twMerge } from 'tailwind-merge';

interface ButtonProps {
  text?: string;
  type?: 'button' | 'submit' | 'reset';
  formId?: string;
  disabled?: boolean;
  dataModalToggleId?: string;
  buttonClassName?: string;
  textClassName?: string;
  leftIcon?: React.ReactNode;
  rightIcon?: React.ReactNode;
  onClick?: (e: MouseEvent<HTMLButtonElement>) => void;
}

export const Button = ({
  text,
  disabled,
  type,
  formId,
  dataModalToggleId,
  buttonClassName,
  textClassName,
  leftIcon,
  rightIcon,
  onClick,
}: ButtonProps) => {
  return (
    <button
      type={type}
      form={formId}
      className={twMerge(
        'btn bg-primary btn-lg h-9 flex justify-center items-center gap-2 px-3 rounded-lg select-none hover:opacity-75',
        buttonClassName
      )}
      disabled={disabled}
      data-modal-toggle={
        dataModalToggleId ? `#${dataModalToggleId}` : undefined
      }
      onClick={onClick}
    >
      {leftIcon && (
        <div className="flex justify-center items-center text-white">
          {leftIcon}
        </div>
      )}
      {text && (
        <span className={twMerge('text-white font-normal', textClassName)}>
          {text}
        </span>
      )}
      {rightIcon && (
        <div className="flex justify-center items-center text-white">
          {rightIcon}
        </div>
      )}
    </button>
  );
};
